import IconH5p from '~/components/icons/h5p.vue';
import IconScorm from '~/components/icons/scorm.vue';

const themes = {
  light: {
    primary : process.env.DEFAULT_PRIMARY_COLOR,
    accent  : process.env.DEFAULT_ACCENT_COLOR,
    grey    : process.env.DEFAULT_GREY_COLOR,
    error   : '#EF5350',
    info    : '#1198CF',
    success : '#00A285',
    warning : '#D08300',
    anchor  : '#176281'
  },
  dark: {
    primary : '#1198CF',
    accent  : process.env.DEFAULT_ACCENT_COLOR,
    grey    : process.env.DEFAULT_GREY_COLOR,
    error   : '#EF5350',
    info    : '#1198CF',
    success : '#00A285',
    warning : '#D08300',
    anchor  : '#176281'
  }
};

const options = {
  theme: {
    options: {
      customProperties : true,
      variations       : true
    },
    dark: false,
    themes
  },
  icons: {
    iconfont : 'mdi',
    values   : {
      h5p: {
        component: IconH5p
      },
      scorm: {
        component: IconScorm
      }
    }
  }
};

export default function({ app }) {
  return {
    ...options,
    lang: {
      t: (key, ...params) => app.i18n.t(`_core.${key}`, params)
    }
  };
}

export {
  options
};
